module.exports = __webpack_public_path__ + "img/product-3.edf324ee.png";